import AccordionContainer from '~/common/components/AccordionContainer';
import QuestionLibraryBuilder from '~/common/components/QuestionLibrary/QuestionLibraryBuilder';

import { useConditionsEvaluator } from '../utils/useConditionsEvaluator';

type AccordionProps = {
  component?: any;
};

/**
 * @typedef {object} AccordionProps
 * @property {import('./../types/component').ComponentTypeProps} component
 *
 * @param {AccordionProps} props
 * @returns
 */
export default function Accordion({ component }: Readonly<AccordionProps>) {
  const {
    title,
    name = 'accordionTestId',
    allowToggle = false,
    allowMultiple = true,
    layoutType,
    children,
    conditions,
  } = component;
  const { isVisible } = useConditionsEvaluator(conditions);
  return (
    <AccordionContainer
      data-testId={name}
      mt={0}
      mb={0}
      header={title}
      allowToggle={allowToggle}
      allowMultiple={allowMultiple}
      layoutType={layoutType}
      accordionPanelProps={{
        padding: 0,
        paddingLeft: 0,
        paddingRight: 0,
      }}
      display={isVisible ? 'block' : 'none'}
      accordionButtonProps={{
        borderBottom: '3px solid #005F9E',
        color: '#005F9E',
        fontSize: '1.5rem',
        padding: 0,
        accordionBgExpanded: 'none',
      }}
      border={'none'}
    >
      <QuestionLibraryBuilder
        questions={children}
        isParentShowing={isVisible}
      />
    </AccordionContainer>
  );
}
